import React, { useState, useEffect } from "react";
import { IoCloseSharp } from "react-icons/io5";
import Button from "../../../../components/Button/button";
import InputComponent from "../../../../components/Input/input";
import Swal from "sweetalert2";
import { GetContribuinteDto } from "../../../../shared/dtos/Contribuinte.dto";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../../../shared/styles/global.styles";
import { BlueStrong, DateInputContainer, InputContainer } from "./styles";
import { Label } from "../../../../components/Label/styles";
import DeclaracaoContribuicaoService from "../../../../services/DeclaracaoContribuicaoService";
import { pdf } from "@react-pdf/renderer";
import DeclaracaoPDF from "../DeclaracaoPDF";

interface DeclaracaoModalProps {
  show: boolean;
  onClose: () => void;
  contribuinte: GetContribuinteDto;
}

const DeclaracaoModal: React.FC<DeclaracaoModalProps> = ({
  show,
  onClose,
  contribuinte,
}) => {
  const currentYear = new Date().getFullYear();
  const [anoInicio, setAnoInicio] = useState<string>(
    currentYear.toString() || ""
  );
  const [anoFinal, setAnoFinal] = useState<string>(
    currentYear.toString() || ""
  );
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [isRequest, setIsRequest] = useState<boolean>(false);
  // Resetar estados quando o modal é aberto
  useEffect(() => {
    if (show) {
      resetarFiltros();
    }
  }, [show, currentYear]);

  // Função para resetar os filtros para valores padrão
  const resetarFiltros = () => {
    setAnoInicio(currentYear.toString());
  };

  const clearError = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name } = event.target;

    setInvalidFields((prev) => prev.filter((field) => field !== name));
  };

  const handleSubmit = async () => {
    setIsRequest(true);
    if (anoInicio === "" || !anoInicio) {
      setInvalidFields((prev) => [...prev, "anoInicio"]);
      Swal.fire({
        icon: "error",
        title: "Campo obrigatório",
        text: "Por favor, preencha o ano para gerar a declaração",
        allowOutsideClick: false,
      });
      setIsRequest(false);
      return;
    }

    Swal.fire({
      title: "Gerando declaração...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await DeclaracaoContribuicaoService.gerarDeclaracao(
      contribuinte.id,
      anoInicio.toString()
    )
      .then(async (response) => {
        if (response) {
          if (response.contribuinte === null) {
            Swal.fire({
              icon: "info",
              title: "Não foi possivel gerar a declaração",
              text: `Contribuinte não possui nenhuma parcela paga no periodo informado!`,
              allowOutsideClick: false,
            });
            return;
          }
          const blob = await pdf(
            <DeclaracaoPDF
              data={{ ...response, anoInicial: anoInicio, anoFinal: anoFinal }}
            />
          ).toBlob();
          const url = URL.createObjectURL(blob);
          window.open(url);
          Swal.fire({
            icon: "success",
            title: "Declaração gerada com sucesso!",
            text: `Declaração gerada com sucesso para ${contribuinte.nome} referente ao ano de ${anoInicio} !`,
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erro ao gerar declaração",
            text: "Por favor, tente novamente",
            allowOutsideClick: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Erro ao gerar declaração",
          text: error.message || "Por favor, tente novamente",
          allowOutsideClick: false,
        });
      })
      .finally(() => {
        setIsRequest(false);
      });
  };

  return (
    <ModalContainer show={show}>
      <ModalContent width={35}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Declaração de recebimento de doações voluntária</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <Label>
            <BlueStrong>Nome:</BlueStrong> {contribuinte.nome}
          </Label>
          <Label>
            <BlueStrong>CPF:</BlueStrong> {contribuinte.cpfCin}
          </Label>

          <InputContainer>
            <Label>Ano para geração da declaração</Label>
            <InputComponent
              type="number"
              name="anoInicio"
              id="anoInicio"
              color="primary"
              placeholder="Ano a ser gerado a declaração de recebimento de doação voluntária"
              width={Number("100%")}
              value={anoInicio}
              onChange={(e) => {
                setAnoInicio(e.target.value.slice(0, 4));
                clearError(e);
              }}
              errorMessage={
                invalidFields.includes("anoInicio") ? "Campo obrigatório" : ""
              }
              disabled={isRequest}
            />
          </InputContainer>
          {/* <InputContainer>
              <Label>Ano final</Label>
              <InputComponent
                type="number"
                name="anoFinal"
                id="anoFinal"
                color="primary"
                placeholder="Ano a ser gerado a declaração de recebimento de doação voluntária"
                width={Number("100%")}
                value={anoFinal}
                onChange={(e) => {
                  setAnoFinal(e.target.value.slice(0, 4));
                  clearError(e);
                }}
                errorMessage={
                  invalidFields.includes("anoFinal") ? "Campo obrigatório" : ""
                }
                disabled={isRequest}
              />
            </InputContainer> */}
        </ModalBody>
        <ModalFooter>
          <Button schemaButton="full-primary" action={() => handleSubmit()}>
            Gerar declaração
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default DeclaracaoModal;
